import React from 'react';
import { Link } from 'react-router-dom';

const links = {
  'Explore': [
    { to: '/about', label: 'About Us' },
    { to: '/initiatives', label: 'Our Initiatives' },
    { to: '/events', label: 'Events' },
    { to: '/gallery', label: 'Gallery' },
  ],
  'Get Involved': [
    { to: '/get-involved', label: 'Volunteer' },
    { to: '/get-involved', label: 'Become a Mentor' },
    { to: '/donate', label: 'Donate' },
    { to: '/contact', label: 'Contact Us' },
  ],
};

function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/assets/logo.jpg" alt="Khisa Foundation"
                className="h-12 w-12 rounded-full object-cover ring-2 ring-red-500/40" />
              <div>
                <p className="font-bold text-white leading-tight">Khisa Foundation</p>
                <p className="text-gray-400 text-xs">for Impact and Empowerment</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Empowering lives and shaping futures through mentorship, pad drives, digital literacy, and community support.
            </p>
            <div className="mt-5">
              <Link to="/donate"
                className="inline-block bg-red-600 hover:bg-red-700 text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-colors duration-200">
                Support Our Mission
              </Link>
            </div>
          </div>

          {/* Navigation columns */}
          {Object.entries(links).map(([heading, items]) => (
            <div key={heading}>
              <h4 className="text-sm font-semibold uppercase tracking-widest text-gray-400 mb-4">{heading}</h4>
              <ul className="space-y-2.5">
                {items.map(({ to, label }) => (
                  <li key={label}>
                    <Link to={to}
                      className="text-gray-300 hover:text-white text-sm transition-colors duration-150">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} Khisa Foundation for Impact and Empowerment. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-gray-600 text-xs">Empowering Lives &middot; Shaping Futures</p>
            <Link to="/admin" className="text-gray-700 hover:text-gray-400 text-xs transition-colors duration-150">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
